// extracted by mini-css-extract-plugin
module.exports = {"messageButton":"clinicalSimulation_messageButton__CeByf"};